import {Form, Formik} from 'formik';
import Header from 'modules/header/farm/main';
import {useState} from 'react';
import {QualifyFormSchema} from './utilities/validationSchema';
import {qualifyInitialValues} from './utilities/initialValues';
import {useNavigate, useParams} from 'react-router-dom';
import {existingUnits} from 'utilities/helper/existingUnitsOption';
import EditQualityFormComponent from 'components/forms/editQuality';
import useGetPostDetail from 'pages/farm/productDetail/hooks/useGetPostDetail';
import DotsLoading from 'components/loadings/dotsLoading';
import {useFarm} from 'context/farmContext';

const EditQualityForm = () => {
  const {guid} = useParams();
  const {productDetail, isLoading} = useGetPostDetail(guid || '');
  const {
    farm,
    uploadQualifyPage,
    updateType,
    updateCultivationGuid,
    setDeleteOldImages,
  } = useFarm();

  const [images, setImages] = useState<IUploadImage[]>(
    farm?.images ? farm.images : [],
  );
  const navigate = useNavigate();
  return (
    <>
      <Header title="ثبت آگهی فروش محصول " />
      {isLoading ? (
        <DotsLoading />
      ) : (
        <Formik
          initialValues={qualifyInitialValues({
            existing: productDetail?.existing.toString(),
            existing_unit: productDetail?.existing_unit,
          })}
          validationSchema={QualifyFormSchema}
          onSubmit={values => {
            const qualifyData = {
              images,
              existing_unit: values.existing_unit,
              existing: values.existing,
            };
            uploadQualifyPage(qualifyData);
            updateType(productDetail?.type || '');
            navigate(`/farm/edit/owner/${guid || ''}`);
            productDetail?.product?.guid &&
              updateCultivationGuid(
                productDetail.guid,
                productDetail?.subproduct?.guid,
              );
          }}
        >
          <Form className="pb-[7vh]">
            <EditQualityFormComponent
              mainImageGuid={productDetail?.main_image?.guid || ''}
              images={images}
              oldImages={productDetail?.images?.filter(
                item => !farm?.deleted_images?.includes(item.guid),
              )}
              existingUnits={existingUnits}
              setImages={setImages}
              removeImage={setDeleteOldImages}
            />
          </Form>
        </Formik>
      )}
    </>
  );
};

export default EditQualityForm;
